import { render, staticRenderFns } from "./dapur.vue?vue&type=template&id=6fb89e60&"
import script from "./dapur.vue?vue&type=script&lang=js&"
export * from "./dapur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports